import theme from '../../../lib/theme';
import { SpinnerProps } from './Spinner';

const {
  colors,
  media,
  scale,
  font: { families },
} = theme;

export default ({ brand = 'sas', backgroundColor = 'none' }: SpinnerProps) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor,
    color: colors[brand].primary,

    '> img': {
      maxWidth: '10vw',

      [media.m.down]: {
        maxWidth: '25vw',
      },

      [media.s.down]: {
        maxWidth: '50vw',
      },
  
    },

    '> p': {
      fontFamily: families.primary,
      fontSize: '2rem',
    },
  },
});